import PropTypes from 'prop-types';

export const formikTypes = {
  handleChange: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
};
